export default __webpack_public_path__ + "static/media/classic_band.0374d422.webp";